module.exports = __webpack_public_path__ + "icon_cached-108e30d96e1d5152be7fe2978bcdfe14.svg";